import React, { useCallback, useEffect, useState } from "react";
import { DomainValue } from "../../services/mdmService/types";
import { getMDMConfiguration } from "../../services/mdmService/mdmService";
import DataUploadStepper from "./dataUploadHomeScreen/stepper/stepper";
import ExcelUploadParentScreen from "./dataUploadHomeScreen/excelUpload/screen/excelUploadParentScreen";
import "./dataUploadScreenLayout.css";
import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import { Box, Button } from "@mui/material";
import MDMstudioLogs from "./dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/logsScreen/logsScreen";
import { ViewAndEdit } from "../../features/editAndView/ViewAndEdit";
import { EditTable } from "./dataUploadHomeScreen/excelUpload/viewAndEdit/editTable";
import StudioRoleDivision from "./dataUploadHomeScreen/roleDivision/studioRoleDivision";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { LogEntity } from "../logsAndReports/reportAndLogsRowTypes";
import { IntegrationDashboard } from "../../features/integrationDashboard/IntegrationDashboard";
import { updateOnboardingStatus, updateProductionMovement } from "../../services/userOnboardService/userOnboardService";
import { useNavigate } from "react-router-dom";

export interface DataUploadScreenPropsTypes {
  handleStepIconClick?: (stepNumber: number) => void;
  currentStep?: number;
  completed?: {
    [k: number]: boolean;
  };
  setCompleted?: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  disableNext?: boolean;
}

export default function DataUploadScreenLayout(
  props: DataUploadScreenPropsTypes
) {
  const [mdmData, setMdmData] = useState<DomainValue[]>([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [optional, setOptional] = useState<string | null>(null);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [completed, setCompleted] = useState<{ [k: number]: boolean }>({});
  const [currentScreen, setCurrentScreen] = useState<
    "default" | "logs" | "edit" | "division" | "integration"
  >("default");
  const [curData, setData] = useState<LogEntity[]>([]);
  const [filteredData, setFilteredData] = useState<LogEntity[]>([]); // To store the search results

  const [selectedMaster, setSelectedMaster] = useState<DomainValue>();
  const navigate = useNavigate();

  const mdmDataConfig = useCallback(async () => {
    const response = await getMDMConfiguration();
    if (response.length === 0) setShowErrorMessage(true);
    console.log(response);
    setMdmData(response);
  }, []);
  useEffect(() => {
    mdmDataConfig();
  }, [mdmDataConfig]);

  useEffect(() => {
    setSelectedMaster(mdmData[0]);
  }, [mdmData]);
  useEffect(() => {
    if (currentScreen === "integration" && currentStep !== 1) {
      setCurrentStep(1);
    } else if (currentScreen === "default" && currentStep !== 0) {
      setCurrentStep(0);
    }
  }, [currentScreen, currentStep]);

  const getLogs = useCallback(async () => {
    const Url = getUrl(selectedMaster?.entity ?? "All");
    const entityData = await ChannelkartNetworkGet(Url);
    const logs = entityData.data.features.filter(
      (log: any) => log.response !== undefined
    );
    setData(logs);
    setFilteredData(logs); // Initially set filtered data as the full data set
  }, [selectedMaster]);

  function getUrl(entity: string) {
    if (entity && entity !== "All") {
      return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload'] and attributes.entityName:${entity}&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
    } else {
      return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload']&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
    }
  }

  useEffect(() => {
    getLogs();
  }, [selectedMaster]);
  const handleStepIconClick = (stepNumber: number) => {
    if (stepNumber === 0) {
      handleScreenSwitch("default");
    } else if (stepNumber === 1) {
      handleScreenSwitch("integration");
    }
    setCurrentStep(stepNumber);
  };
  const handleScreenSwitch = (
    screen: "default" | "logs" | "edit" | "division" | "integration"
  ) => {
    setCurrentScreen(screen);
  };

  const renderNextStepButton = (left: string) => (
    <>
      { !props.disableNext ?
        <Box
          marginTop={2}
          sx={{
            width: "40vw",
            position: "absolute",
            display: "flex",
            flexDirection: "row-reverse",
            bottom: "32px",
            left: left,
          }}
        >
          <Button
            // onClick={() => {
            //   if (currentScreen === "default") {
            //     props.setCompleted!((prev) => ({
            //       ...prev,
            //       [props.currentStep!]: true,
            //     }));
            //     props.handleStepIconClick!(4);
            //     // Move to Integration Screen from default
            //     // handleScreenSwitch("integration");   currently disabling this flow as told by BA need to uncomment this to go to integration screen
            //   } else if (currentScreen === "integration") {
            //     // Trigger handleStepIconClick(5) on Integration Screen
            //     props.setCompleted!((prev) => ({
            //       ...prev,
            //       [props.currentStep!]: true,
            //     }));
            //     props.handleStepIconClick!(4);
            //   }
            // }}
            onClick={async() => {
              await updateProductionMovement(true, async () => {
                props.setCompleted!((prev) => ({
                  ...prev,
                  [props.currentStep!]: true,
                }));
                // props.handleStepIconClick!(4);
                await updateOnboardingStatus(false);
                navigate("/dashboard", {
                    state: {
                        showProductionMovementSuccessPopup: true
                    }
                });
            },true);
            }}
            endIcon={
              <ArrowRightAltTwoToneIcon
                sx={{ fontSize: { xl: "50px" }, color: "white" }}
              />
            }
            style={{
              height: "2rem",
              padding: "20px 10px",
            }}
            sx={{
              background: "#237C9D",
              "&:hover": {
                background: "#237C9D",
              },
              fontWeight: "bold",
              fontSize: "16px",
              color: "white",
            }}
          >
            Go To Portal
          </Button>
        </Box> : <></>
      }
    </>
  );

  const renderHeaderWithStepper = () => (
    <div className="mdm-header">
      <DataUploadStepper
        optional={optional}
        currentStep={currentStep}
        handleStepIconClick={handleStepIconClick}
        completed={completed}
        setCompleted={setCompleted}
        parentHandleStepIconClick={props.handleStepIconClick}
        showBack={!props.disableNext}
      />
    </div>
  );

  const renderExcelUploadScreen = () => {
    switch (currentScreen) {
      case "default":
        return (
          <div className="excel-container">
            {renderHeaderWithStepper()}
            <p style={{ marginLeft: "30px" }}>
              Effortlessly integrate your data by uploading your master files.
            </p>
            <h4>Let's Get Started</h4>
            <ExcelUploadParentScreen
              handleStepIconClick={handleStepIconClick}
              currentStep={0}
              completed={completed}
              setCompleted={setCompleted}
              mdmData={mdmData}
              setMdmData={setMdmData}
              handleScreenSwitch={handleScreenSwitch}
              selectedMaster={selectedMaster}
              setSelectedMaster={setSelectedMaster}
              curData={curData}
              filteredData={filteredData}
              getLogs={getLogs}
              isNextDisabled={props.disableNext}
            />
            {renderNextStepButton("815px")}
          </div>
        );
      case "logs":
        return (
          <Box sx={{ position: "relative", height: "100%", width: "100%" }}>
            <MDMstudioLogs
              currentMaster={selectedMaster}
              handleScreenSwitch={handleScreenSwitch}
              headingTitle={"See logs"}
              curData={curData}
              setData={setData}
              filteredData={filteredData}
              setFilteredData={setFilteredData}
            />
          </Box>
        );
      case "edit":
        return (
          <Box sx={{ position: "relative", height: "80vh", width: "100%" }}>
            <EditTable
              selectedMaster={selectedMaster}
              handleScreenSwitch={handleScreenSwitch}
              headingTitle={`Edit a record for ${selectedMaster?.name}`}
            />
          </Box>
        );
      case "division":
        return (
          <Box
            sx={{
              position: "relative",
              height: "80vh",
              width: "100%",
              overflow: "scroll",
            }}
          >
            <StudioRoleDivision handleScreenSwitch={handleScreenSwitch} />
          </Box>
        );

      default:
        return null;
    }
  };

  const renderIntegrationScreen = () => (
    <>
      {renderHeaderWithStepper()}
      <div style={{ overflow: "scroll", height: "80vh" }}>
        <IntegrationDashboard />
      </div>
      {renderNextStepButton("815px")}
    </>
  );

  const renderCurrentTab = (tab: number) => {
    switch (tab) {
      case 0:
        return renderExcelUploadScreen();
      case 1:
        return renderIntegrationScreen();
      default:
        return <></>; // Fallback case
    }
  };

  return (
    <>
      {showErrorMessage ? (
        <div className="mdm-error">
          <div className="mdm-card-error-msz">
            {" "}
            Cards are not available for Now, Kindly refresh
          </div>
        </div>
      ) : (
        <div className="mdm-screen">
          <>{renderCurrentTab(currentStep)}</>
        </div>
      )}
    </>
  );
}
